import { RootState } from '../../main/store/main.store.ts';

import { ScriptReplacementKey } from '../slices/scripts/scripts.slice.types.ts';

export const selectReplacements = (state: RootState): Partial<Record<ScriptReplacementKey, string>> =>
  state.scripts.replacements;
